import {
  ReviewBreakpointConfig as IReviewBreakpointConfig,
  ReviewsListConfig as IReviewsListConfig
} from 'services/api-service'

type RelatedReviewsDisplayType = 'NONE' | 'INCLUDED' | 'SEPARATE'

export enum RelatedReviewsDisplayTypes {
  NONE = 'NONE',
  INCLUDED = 'INCLUDED',
  SEPARATE = 'SEPARATE'
}

export class ReviewsListConfig implements IReviewsListConfig {
  constructor(config: IReviewsListConfig) {
    this.breakpoints = config.breakpoints
    this.defaultSortOption = config.defaultSortOption
    this.displayUserToolbar = config.displayUserToolbar
    this.hideWriteReview = config.hideWriteReview
    this.initialPageSize = config.initialPageSize
    this.pageSize = config.pageSize
    this.relatedReviewsDisplay = config.relatedReviewsDisplay
    this.relatedInitialPageSize = config.relatedInitialPageSize
    this.relatedPageSize = config.relatedPageSize
    this.showPurchaserBadge = config.showPurchaserBadge
    this.sortOptions = config.sortOptions
    this.toggleFiltersDesktop = config.toggleFiltersDesktop
    this.toggleFiltersMobile = config.toggleFiltersMobile
    this.useShowMore = config.useShowMore
    this.widgetDivId = config.widgetDivId
  }

  breakpoints: Array<IReviewBreakpointConfig>
  defaultSortOption: string
  displayUserToolbar: boolean
  hideWriteReview: boolean
  initialPageSize: number
  pageSize: number
  relatedReviewsDisplay: RelatedReviewsDisplayType
  relatedInitialPageSize: number
  relatedPageSize: number
  showPurchaserBadge: boolean
  sortOptions: string[]
  toggleFiltersDesktop: boolean
  toggleFiltersMobile: boolean
  useShowMore: boolean
  widgetDivId: string
}

let defaultConfig: IReviewsListConfig = {}
export function loadConfig(config: IReviewsListConfig) {
  defaultConfig = new ReviewsListConfig(config)
}

export { defaultConfig as default }



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/widgets/reviews-list/reviews-list-widget.config.ts